import React, { useState } from 'react';
import { Modal, Button, Alert, Spinner} from 'react-bootstrap';
import { useMutation, useQueryClient } from 'react-query';
import { IWebLink } from '../../models/webLink';
import { refreshWebLink } from '../../api/agent';
import { ObjectId } from '../../models';

type Props = {
	orgId: ObjectId;
	webLink: IWebLink;
	setRefreshWebLink: React.Dispatch<React.SetStateAction<IWebLink | undefined>>
}


const RefreshWebLink = ({orgId, webLink, setRefreshWebLink} : Props) => {
	const [error, setError] = useState<string | null>(null);
	const handleClose = () => setRefreshWebLink(undefined);

	const queryClient = useQueryClient();
	const { mutateAsync: refreshWebLinkFn, isLoading } = useMutation(
		refreshWebLink, // mutation function goes here
		{
			onSuccess: () => {
				// queryClient.invalidateQueries(['Agents']);
				queryClient.invalidateQueries(['WebLinks', webLink.agentId]);
				handleClose();
			},
			onError: (error) => {
				setError("Failed to delete.")
			},
		}
	);

	const handleRefresh = async () => {
		refreshWebLinkFn({
			orgId,
			agentId: webLink.agentId,
			id: webLink.id
		});
	}

	return (
		<Modal show={!!webLink} onHide={handleClose} size='sm'>
			<Modal.Header closeButton>
				<Modal.Title>Confirm Refresh?</Modal.Title>
			</Modal.Header>
			
			{error && (
				<Modal.Body>
					<Alert variant="danger" className="mt-3">
						{error}
					</Alert>
				</Modal.Body>
			)}
			
			<Modal.Footer>
			<Button variant="secondary" onClick={handleClose}>
				Close
			</Button>
			<Button variant="primary" onClick={handleRefresh}>
				{isLoading ? <Spinner/> : "Refresh"}
			</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default RefreshWebLink;
